const API_BASE = process.env.REACT_APP_API_URL || 'https://iceswap.io';

// Normal swap API calls
export const fetchAssets = async () => {
  const res = await fetch(`${API_BASE}/api/assets`);
  if (!res.ok) throw new Error('Failed to load the coin list. Please refresh and try again.');
  return res.json();
};

export const estimateSwap = async (params) => {
  const res = await fetch(`${API_BASE}/api/estimate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  if (!res.ok) throw new Error("We couldn't get a rate for that pair right now.");
  return res.json();
};

export const createQuote = async (params) => {
  const res = await fetch(`${API_BASE}/api/quote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  if (!res.ok) throw new Error("We couldn't start that exchange. Double-check your addresses and try again.");
  return res.json();
};

export const getOrderStatus = async (orderId) => {
  const res = await fetch(`${API_BASE}/api/status/${orderId}`);
  if (!res.ok) throw new Error("We couldn't find that order.");
  return res.json();
};

// SplitNow (private XMR) API calls
export const getSplitNowOrder = async (orderId) => {
  const res = await fetch(`${API_BASE}/api/cex/order/${orderId}`);
  if (!res.ok) throw new Error("We couldn't find that order.");
  return res.json();
};

export const createSplitNowQuote = async (params) => {
  const res = await fetch(`${API_BASE}/api/cex/quote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  if (!res.ok) throw new Error("We couldn't get a rate right now.");
  return res.json();
};

export const createSplitNowOrder = async (params) => {
  const res = await fetch(`${API_BASE}/api/cex/order`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  if (!res.ok) throw new Error("We couldn't start that exchange. Double-check your addresses and try again.");
  return res.json();
};
